import DOMPurify from 'dompurify';

/**
 * Sanitize untrusted HTML before injecting via dangerouslySetInnerHTML.
 * Strips <script>, on* event handlers, javascript: URIs, and other XSS vectors
 * while preserving formatting used by the TipTap-based RichTextEditor
 * (headings, paragraphs, lists, blockquotes, links, images, bold/italic, etc.).
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });
};

export default sanitizeHtml;
